module.exports = __webpack_public_path__ + "img/ancien-permis-l.8f69ec91.jpg";